import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
export const API = `${baseUrl}/api`;

export const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Categories
export const getCategories = () => api.get("/categories");

// Card Generation
export const generateCards = (data) => api.post("/generate-cards", data);

// Projects
export const getProject = (id) => api.get(`/projects/${id}`);
export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
export const updateCard = (projectId, data) =>
  api.put(`/projects/${projectId}/card`, data);
export const regenerateCard = (projectId, cardId) =>
  api.post(`/projects/${projectId}/regenerate-card`, { card_id: cardId });

// Waitlist
export const joinWaitlist = (data) => api.post("/waitlist", data);

// Admin
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password });
export const adminLogout = () => api.post("/admin/logout");
export const getLeads = () => api.get("/admin/leads");
export const getAnalytics = () => api.get("/admin/analytics");
export const exportLeadsCSV = () =>
  api.get("/admin/leads/export", { responseType: "blob" });
export const getMockedEmails = () => api.get("/admin/emails");
export const getTopicHeatmap = () => api.get("/admin/topic-heatmap");

// Analytics tracking
export const trackEvent = (
  eventType,
  page = null,
  buttonId = null,
  metadata = null,
) => {
  return api
    .post("/analytics/track", {
      event_type: eventType,
      page,
      button_id: buttonId,
      metadata,
    })
    .catch(() => {}); // Silent fail for analytics
};

export const trackPageView = (page) => trackEvent("page_view", page);
export const trackButtonClick = (buttonId, page = null) =>
  trackEvent("button_click", page, buttonId);

export default api;
